import script from "./TimetableAlertOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableAlertOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableAlertOverlay.vue?vue&type=style&index=0&id=2617a0c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2617a0c4"]])

export default __exports__